





























import AbpBase from "../../../lib/abpbase"; 
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetDicTemps,GetDicTempsByType,SaveDicDict} from '../../../api/systemBasic'
import util from '../../../lib/util'

@Component({})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    typeName = ''
    form:any = {
        pItemCode:this.data.info.pItemCode,
        pItemDesc:this.data.info.pItemDesc,
        itemName:'',
        orderBy:99, 
        itemCode:'',
    }
    created() {
        console.log(this.data)
        if(this.data.title=='编辑'){
            this.form = Object.assign({},this.data.row)
            console.log(this.form)
        }
    }
    rules = {
        itemName:[{required: true,message:this.L('FieldIsRequired'),trigger: 'blur'}],
        itemCode:[{required: true,message:this.L('FieldIsRequired'),trigger: 'blur'}],
    }
    cancel(){
        (this.$refs.form as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    async save(){
        (this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
                let res = await SaveDicDict(this.form)
                if(res.status==1){
                    this.$emit('input',false);
                    this.$emit('on-success')
                }
            }
        })
        
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tempManage/dic/model.vue